import { useParams } from "react-router-dom";
import React from "react";
import ReturnGoods from "../../../../containers/Print/default/Return-Goods";
export const PrintReturnGoods = (props)=>{
    let params=useParams();
    let id=params.id;
    document.getElementById("root").setAttribute("style","overflow:hidden");
    return (
        <ReturnGoods id={id}/>
    )
}

export default PrintReturnGoods;